@import "tailwindcss";

@theme {
  --font-heading: "Space Grotesk", system-ui, sans-serif;
  --font-body: "DM Sans", system-ui, sans-serif;
  --color-bg-primary: #0f172a;
  --color-bg-secondary: #1e293b;
  --color-bg-tertiary: #334155;
  --color-text-primary: #f1f5f9;
  --color-text-secondary: #cbd5e1;
  --color-text-muted: #64748b;
  --color-text-link: #60a5fa;
  --color-border-default: #334155;
  --color-border-strong: #475569;
  --color-risk-low: #16a34a;
  --color-risk-low-light: #22c55e;
  --color-risk-moderate: #ca8a04;
  --color-risk-moderate-light: #eab308;
  --color-risk-high: #ea580c;
  --color-risk-high-light: #f97316;
  --color-risk-critical: #dc2626;
  --color-risk-critical-light: #ef4444;
  --color-accent: #3b82f6;
  --color-accent-light: #60a5fa;
  --color-accent-purple: #8b5cf6;
  --color-success: #4ade80;
  --color-success-bg: #052e16;
  --color-warning: #facc15;
  --color-warning-bg: #422006;
  --color-error: #f87171;
  --color-error-bg: #450a0a;
  --color-info: #60a5fa;
  --color-info-bg: #172554;
  --shadow-card: 0 4px 12px rgba(0, 0, 0, 0.4);
  --shadow-card-hover: 0 10px 25px rgba(0, 0, 0, 0.5);
  --shadow-glow-purple: 0 0 24px -6px rgba(139, 92, 246, 0.15);
  --radius-card: 12px;
}

body {
  margin: 0;
  font-family: var(--font-body);
  background-color: #0f172a;
  color: #f1f5f9;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}